import React from "react"
import { makeStyles } from "@material-ui/core/styles"

import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TableRow from "@material-ui/core/TableRow"

import { Scope } from "@ua/web-sdk/lib/remote-data/preference-center"
import { SubscriptionList } from "@root/store/types"
import ScopedListItem from "./ScopedListItem"
import UnscopedListItem from "./UnscopedListItem"

const useStyles = makeStyles({
  table: {
    minWidth: 300,
  },
})
export interface Props {
  type: "contact" | "channel"
  lists: SubscriptionList[]
  onRemoveList: (list: string, scope?: Scope) => void
  onAddList: (list: string, scope?: Scope) => void
}

const SubscriptionsTable: React.FC<Props> = ({
  type,
  lists,
  onRemoveList,
  onAddList,
}) => {
  const classes = useStyles()

  return (
    <TableContainer>
      <Table className={classes.table} aria-label="Subscriptions">
        <TableHead>
          <TableRow>
            <TableCell>List ID</TableCell>
            <TableCell>{type === "contact" ? "Scopes" : ""}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {lists.map((list) => (
            <TableRow
              key={list.id}
              data-qa-selector={`subscriptions-row-${list}`}
            >
              {list.scopes && (
                <ScopedListItem
                  list={list}
                  onAddList={onAddList}
                  onRemoveList={onRemoveList}
                />
              )}
              {!list.scopes && (
                <UnscopedListItem list={list} onRemoveList={onRemoveList} />
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default SubscriptionsTable
